// extracted by mini-css-extract-plugin
export default {"inputWithInfo":"Wo4TlqekTC","infoButton":"XVtMm414Nm"};